import { ROUTE_PATHS, ROUTES } from 'routes/consts';
import { type StepConfig } from 'shared/MultiStepDialog';
import { spawn } from 'utils/translations';
import { FORM_IDS, STEP_IDS } from './consts';

const spawnSteps = spawn('dialogs.gitlab-installation-v2.steps');

/**
 * The v2 wizard steps. Route-driven (like every other install wizard): each step
 * is a nested route under the single `/integrations/gitlab` parent, rendered via
 * the MultiStepDialog Outlet.
 * @returns The ordered step configs for the MultiStepDialog.
 */
export const getSteps = (): StepConfig[] => [
  {
    id: STEP_IDS.CONNECT,
    path: `${ROUTES.GITLAB_INSTALLATION}/${ROUTE_PATHS.GITLAB_V2_CONNECT}`,
    title: spawnSteps('connect.title'),
    shouldShowBackButton: false,
    shouldShowCancelButton: true,
    // Next submits the connect form (formId), so it must start enabled —
    // onSuccess advances.
    formId: FORM_IDS.CONNECT,
    isNextInitiallyEnabled: true,
  },
  {
    id: STEP_IDS.SELECT,
    path: `${ROUTES.GITLAB_INSTALLATION}/${ROUTE_PATHS.GITLAB_V2_SELECT}`,
    title: spawnSteps('select.title'),
    shouldShowBackButton: true,
    // Next is gated on a non-empty selection (the step drives setIsNextEnabled).
    isNextInitiallyEnabled: false,
  },
  {
    id: STEP_IDS.INSTALL,
    path: `${ROUTES.GITLAB_INSTALLATION}/${ROUTE_PATHS.GITLAB_V2_INSTALL}`,
    title: spawnSteps('install.title'),
    // No Back: provisioning already happened; failures retry in place instead.
    shouldShowBackButton: false,
    nextLabel: spawnSteps('install.next-label'),
    // "Done" stays disabled until the install poll reaches a terminal state.
    isNextInitiallyEnabled: false,
  },
];
